import Bowser from "bowser/bundled";
import { default as i18n } from "./compat/i18n.json";

const ANALYTICS_URL = "https://analytics.kopfkunst.net";

function getMessage(key) {
  var lang = document.documentElement.lang;
  var messages = i18n[lang] || i18n.en;
  if (messages && messages[key]) {
    return messages[key];
  } else {
    return "missing resource: " + key;
  }
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var cookieArr = decodedCookie.split(";");
  for (var i = 0; i < cookieArr.length; i++) {
    var cookie = cookieArr[i];
    while (cookie.charAt(0) == " ") {
      cookie = cookie.substring(1);
    }
    if (cookie.indexOf(name) == 0) {
      return cookie.substring(name.length, cookie.length);
    }
  }
  return "";
}

function checkBrowser() {
  var browser = Bowser.getParser(window.navigator.userAgent);
  console.log("Current browser: " + JSON.stringify(browser.getBrowser()));
  var invalidBrowser = browser.satisfies({
    "internet explorer": "<9999", // not any version of internet explorer
  });
  if (!invalidBrowser) {
    return true;
  } else {
    console.log("Browser is unsupported: " + invalidBrowser);
    if (
      window.zebDshAppFrameConfig &&
      window.zebDshAppFrameConfig.disableBrowserCheck
    ) {
      console.log("Ignoring browser check");
      return false;
    }
    var cookieName = "zebdshIgnoreUnsupportedBrowser";
    var cookieValue = getCookie(cookieName);
    if (cookieValue == "true") {
      console.log("Ignoring browser check by cookie");
      return false;
    }
    var mainMessage = getMessage("message browser unsupported");
    var subMessage = getMessage("message browser needs update");
    var closeTooltip = getMessage("tooltip button close");
    var insertContentHere = document.getElementById("zebdshbrowserunsupported");
    if (!insertContentHere) {
      insertContentHere = document.createElement("div");
      insertContentHere.className = "zebdshbrowserunsupported";
      insertContentHere.id = "zebdshbrowserunsupported";
      document.body.appendChild(insertContentHere);
      insertContentHere.innerHTML =
        '<div class="verticalcenter"><h1>' +
        mainMessage +
        "</h1>" +
        subMessage +
        '<p class="right"><a href="#" class="buttonclose" id="zebdshbrowserunsupportedbutton" title="' +
        closeTooltip +
        '">&times;</a></p></div>';
      var buttonClose = document.getElementById(
        "zebdshbrowserunsupportedbutton"
      );
      if (buttonClose) {
        buttonClose.addEventListener("mousedown", function () {
          document.cookie = cookieName + "=true;path=/";
          insertContentHere.style.display = "none";
          return false;
        });
      }
    }
    insertContentHere.style.display = "table";
    return false;
  }
}

var zebDshAppFrameBrowserChecked = false;

function checkBrowserOnce(eventName) {
  if (zebDshAppFrameBrowserChecked) {
    console.log("Browser was already checked before: %s", eventName);
  } else if (document.body) {
    zebDshAppFrameBrowserChecked = true;
    console.log("Checking browser while running: %s", eventName);
    checkBrowser();
  } else {
    console.log("Postpone checking browser from: %s", eventName);
  }
}

document.addEventListener("DOMContentLoaded", function (event) {
  checkBrowserOnce("document event");
});

window.addEventListener("load", function (event) {
  checkBrowserOnce("window event");
});

checkBrowserOnce("main");

function handleError(event) {
  try {
    console.error("[zebdshappframe] handling error:", event);
    var className = "zebdshscripterror";
    var mainMessage = getMessage("message script error");

    var mailToIsButton = false;
    var mailToSupportClass = "mailtosupportsimple";
    var mailToHRef = null;
    if (
      "zebDshCompatSupportCreateMailTo" in window &&
      window.zebDshCompatSupportCreateMailTo
    ) {
      try {
        mailToHRef = window.zebDshCompatSupportCreateMailTo();
        mailToIsButton = true;
        mailToSupportClass = "mailtosupportbtn";
      } catch (ex) {
        console.error("[zebdshappframe] failed creating mail-to in compat", ex);
      }
    }

    var subMessage =
      getMessage("message contact support base") +
      '<div class="' +
      mailToSupportClass +
      '" id="zebdshscripterrormailto">' +
      getMessage("message contact support email") +
      "</div>";

    if (event && event.target instanceof HTMLScriptElement) {
      // loading error on script element
      mainMessage = getMessage("message script loading error");
      if (event.target.src && event.target.src.startsWith(ANALYTICS_URL)) {
        mainMessage = getMessage("message script blocked");
        subMessage = getMessage("message disable adblocker");
        className = "zebdshscriptwarning";
      }
    }
    var closeTooltip = getMessage("tooltip button close");
    var insertContentHere = document.getElementById("zebdshscripterror");
    if (!insertContentHere) {
      insertContentHere = document.createElement("div");
      insertContentHere.id = "zebdshscripterror";
      document.body.appendChild(insertContentHere);
    }
    insertContentHere.className = className;
    insertContentHere.innerHTML =
      '<div class="verticalcenter"><h1>' +
      mainMessage +
      "</h1>" +
      subMessage +
      '<p class="right"><a href="#" class="buttonclose" id="zebdshscripterrorbutton" title="' +
      closeTooltip +
      '">&times;</a></p></div>';
    var buttonClose = document.getElementById("zebdshscripterrorbutton");
    if (buttonClose) {
      buttonClose.addEventListener("mousedown", function () {
        insertContentHere.style.display = "none";
        return false;
      });
    }
    var buttonMailTo = document.getElementById("zebdshscripterrormailto");
    if (mailToIsButton && buttonMailTo) {
      buttonMailTo.addEventListener("click", function () {
        location.href = mailToHRef;
        return false;
      });
    }
    insertContentHere.style.display = "table";
  } catch (ex) {
    console.error("[zebdshappframe] error handler with exception", ex);
  }
}

window.addEventListener("error", handleError, true);
